import { render, staticRenderFns } from "./menuAuthBtn.vue?vue&type=template&id=a68921ae"
import script from "./menuAuthBtn.vue?vue&type=script&lang=js"
export * from "./menuAuthBtn.vue?vue&type=script&lang=js"
import style0 from "./menuAuthBtn.vue?vue&type=style&index=0&id=a68921ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports